/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Next_TitleInputs */

const en_contact_next_title = /** @type {(inputs: Contact_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What happens next`)
};

const lv_contact_next_title = /** @type {(inputs: Contact_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kas notiek tālāk`)
};

/**
* | output |
* | --- |
* | "What happens next" |
*
* @param {Contact_Next_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_next_title = /** @type {((inputs?: Contact_Next_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Next_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_next_title(inputs)
	return en_contact_next_title(inputs)
});